import React, { FunctionComponent, ReactNode } from 'react';
import { Intl } from '@erecruit/core';

import {
  Input,
  TextArea,
  DatePicker,
  InputNumber,
  Checkbox,
  Currency,
  TimePicker,
} from '@erecruit/ui-kit';

import { SelectField, FormFieldItem } from './Fields';

import { dynamicFields, DynamicFieldSections } from './helpers';
import { PositionField, FormFieldType } from '../../types';

const { injectIntl } = Intl;

const getDynamicFormItems = (
  section: keyof DynamicFieldSections,
  fields: PositionField[],
) => {
  return fields.filter(field =>
    dynamicFields[section].find(
      dynamicFieldType => dynamicFieldType === field.fieldType,
    ),
  );
};

type RenderFormItems = (
  field: PositionField,
  messageFormatId: string,
) => React.ReactNode;

const renderFormItem: RenderFormItems = (field, messageFormatId) => {
  let Field: ReactNode = null;
  const isDisabled = field.settings && field.settings.locked;
  switch (field.formFieldType) {
    case FormFieldType.TextArea:
      Field = (
        <TextArea
          key={field.fieldType}
          disabled={isDisabled}
          autoSize={{ minRows: 4 }}
        />
      );
      break;
    case FormFieldType.Date:
      Field = <DatePicker key={field.fieldType} disabled={isDisabled} />;
      break;
    case FormFieldType.Time:
      Field = <TimePicker key={field.fieldType} disabled={isDisabled} />;
      break;
    case FormFieldType.SingleSelect:
      return (
        <SelectField
          key={field.fieldType}
          field={field}
          messageFormatId={messageFormatId}
        />
      );
    case FormFieldType.MultiSelect:
      return (
        <SelectField
          key={field.fieldType}
          field={field}
          multi
          messageFormatId={messageFormatId}
        />
      );
    case FormFieldType.Number:
      Field = <InputNumber key={field.fieldType} />;
      break;
    case FormFieldType.Boolean:
      Field = <Checkbox key={field.fieldType} defaultChecked={field.value} />;
      break;
    case FormFieldType.Currency:
      Field = <Currency key={field.fieldType} />;
      break;
    default:
      //FormFieldType.Text:
      Field = <Input key={field.fieldType} disabled={isDisabled} />;
  }
  return (
    <FormFieldItem field={field} messageFormatId={messageFormatId}>
      {Field}
    </FormFieldItem>
  );
};

interface DynamicFormItemsProps {
  section: keyof DynamicFieldSections;
  fields: PositionField[];
  messageFormatId?: string;
}

const DynamicFormItems: FunctionComponent<DynamicFormItemsProps &
  Intl.InjectedIntlProps> = ({
  section,
  fields,
  messageFormatId = 'vms.newPositionWizard',
}) => {
  const dynamicFormItems = getDynamicFormItems(section, fields);

  return (
    <div key={section}>
      {dynamicFormItems.map(field => renderFormItem(field, messageFormatId))}
    </div>
  );
};

export default injectIntl(DynamicFormItems);
